import { bootstrapApplication } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app/app.routes';
import { NavComponent } from './app/nav/nav.component';
import { NotificationComponent } from './app/shared/notification/notification.component';
import { httpProviders } from './app/providers/http.provider';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { signal } from '@angular/core';
import {NgIf} from "@angular/common";
import {environment} from "./environments/environment";
import {FooterComponent} from "./app/shared/footer/footer.component";

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, NavComponent, NotificationComponent, NgIf, FooterComponent],
    template: `
        <app-notification></app-notification>
        <app-nav *ngIf="showNav()"></app-nav>
        <div class="main-content" [class.sticky-footer-padding]="stickyFooter()">
            <router-outlet></router-outlet>
        </div>
        <app-footer [isSticky]="stickyFooter()"></app-footer>
    `,
    styles: [`
        :host {
            display: flex;
            flex-direction: column;
            min-height: 100vh;
        }

        .main-content {
            flex: 1;
            display: flex;
            flex-direction: column;
        }

        .main-content.sticky-footer-padding {
            padding-bottom: 60px; /* Platz für sticky footer */
        }

        @media (max-width: 768px) {
            .main-content.sticky-footer-padding {
                padding-bottom: 80px; /* Mehr Platz auf mobilen Geräten */
            }
        }
    `]
})
export class App {
    showNav = signal(true);
    stickyFooter = signal(true); // Standardmäßig sticky aktiviert

    constructor(private router: Router) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any) => {
            this.showNav.set(event.url !== '/login' && event.url !== '/logout');
        });
    }

    // Methode zum Umschalten des Footer-Modus (optional für zukünftige Verwendung)
    toggleStickyFooter() {
        this.stickyFooter.set(!this.stickyFooter());
    }
}

async function initializeApp() {
    try {
        await bootstrapApplication(App, {
            providers: [
                provideRouter(routes),
                ...httpProviders,
                provideAnimations()
            ]
        });
    } catch (error) {
        console.error('Failed to initialize app:', error);
    }
}

initializeApp().catch(err => console.error(err));